import { U21Button } from 'app/shared/u21-ui/components';
import { useState } from 'react';
import { EditDataLabelsModal } from 'app/modules/dataLabels/EditDataLabelsModal';

interface IProps {
  objectDisplayName: string;
  tagIds: (string | number)[];
  editObjectTags: (tagIds: (string | number)[]) => Promise<void>;
  isEditLoading: boolean;
}

export const EditAssociatedDataLabelsButton = ({
  objectDisplayName,
  tagIds,
  editObjectTags,
  isEditLoading,
}: IProps) => {
  const [editDataLabelsModalOpen, setEditDataLabelsModalOpen] = useState(false);
  return (
    <>
      <U21Button
        aria-label="Edit Tags"
        size="small"
        onClick={() => {
          setEditDataLabelsModalOpen(true);
        }}
      >
        Edit Tags
      </U21Button>
      <EditDataLabelsModal
        editObjectTags={editObjectTags}
        isEditLoading={isEditLoading}
        tagIds={tagIds}
        title={`Edit ${objectDisplayName} Tags`}
        open={editDataLabelsModalOpen}
        handleClose={() => {
          setEditDataLabelsModalOpen(false);
        }}
      />
    </>
  );
};
